import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import { MaterialReactTable } from 'material-react-table';


const RightTable = ({ rightTableData, setSelectedItemsInRight, rightTableRowSelection, setRightTableRowSelection ,cmsData}) => {
    const tableInstanceRef = useRef(null);
    const fetchThoughtLeadershipDetailsCMSLabel=(key)=>{
        if(cmsData?.Components && cmsData?.Components["ThoughtLeadershipDetails"]){
           const ThoughtLeadershipDetailsLabel=cmsData?.Components["ThoughtLeadershipDetails"];
              return returnLabel(ThoughtLeadershipDetailsLabel?.Labels, key)
        }
        return '';
    }
    
    const returnLabel = (labelArray=[], key) => {
          return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    const columns = useMemo(
        () => [
            {
                accessorKey: "ClientAccountName",
                header: fetchThoughtLeadershipDetailsCMSLabel('ThoughtLeadershipDetails.ClientAccountName'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder:fetchThoughtLeadershipDetailsCMSLabel("ThoughtLeadershipDetails.PlaceholderClientAccountName") }
            },
        ],
        []
    );

    useEffect(() => {
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        // console.log("tl-selected:", selectedRowObjList)
        setSelectedItemsInRight(selectedRowObjList)
    }, [rightTableRowSelection])

    return (
        <Fragment>
            {
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={rightTableData}
                    layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    enableRowSelection
                    getRowId={(originalRow) => originalRow.Id} //give each row a more useful id
                    onRowSelectionChange={setRightTableRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection: rightTableRowSelection }}
                    enableStickyHeader
                    muiTableContainerProps={{
                        sx: {
                            height: { sx: 200, sm: 300, md: 500 },
                        }
                    }}
                />
            }
        </Fragment>

    );
};

export default RightTable;
